export const tedeeConfig = {
  common: {
    saving: "Enregistrement...",
    connected: "Connecté",
    disconnected: "Déconnecté",
    lockFallbackNamed: "Serrure {id}",
    deviceFallbackNamed: "Appareil Tedee {id}",
    unitFallback: "Logement",
    unitFallbackNamed: "Logement {id}",
  },

  credentials: {
    title: "Configuration Tedee",
    apiVersionInUse: "Version de l'API utilisée :",
    savedKey: "Clé enregistrée",
    noKey: "Aucune clé",
    keyLabel: "Personal Access Key",
    keyPlaceholderSaved: "•••••••• (enregistrée, modification facultative)",
    keyPlaceholderNew: "Saisissez votre Personal Access Key Tedee",
    keyHintSaved: "Vous pouvez la laisser vide si vous avez déjà une clé enregistrée.",
    keyHintNew: "Obtenez votre clé depuis le portail Tedee.",
    testing: "Test en cours...",
    test: "Tester la connexion",
    save: "Enregistrer les identifiants",
  },

  selector: {
    title: "Sélecteur de serrures pour cet hébergement",
    subA: "Sélectionnez uniquement les serrures qui s'appliquent à",
    subBold: "cet hébergement",
    subB: ". Vous ne verrez ensuite que celles sélectionnées dans le PMS.",
    selectedCount: "{count} sélectionnée(s)",
    hintNoKeyA: "Saisissez votre Personal Access Key et appuyez sur",
    hintNoKeyBold: "Tester la connexion",
    hintNoKeyB: "pour charger vos serrures.",
    emptyDevices:
      "Nous n'avons trouvé aucune serrure ni portail dans votre compte Tedee. Assurez-vous que l'appareil est enregistré et partagé avec le compte dont vous avez enregistré la clé ci-dessus.",
    placeholder: "Sélectionnez des serrures…",
    summaryCount: "{count} serrure(s) sélectionnée(s)",
    summaryEmpty: "Aucune serrure sélectionnée",
    save: "Enregistrer les serrures pour cet hébergement",
  },

  pms: {
    title: "Contrôle et attribution (PMS)",
    subA:
      "Seules les serrures que vous avez enregistrées pour cet hébergement apparaissent ici. Attribuez chacune à",
    subBold1: "Porte principale",
    subOr: "ou",
    subBold2: "Logement",
    subEnd: ".",
    assignedCount: "{count} attribuée(s)",
    empty: {
      A: "Vous n'avez pas encore de serrures enregistrées pour cet hébergement. Utilisez le",
      bold: "sélecteur",
      B: "ci-dessus, puis enregistrez.",
    },
    assignmentLabel: "Attribution",
    assignmentNone: "Non attribuée",
    assignmentGate: "Porte principale (portail)",
    assignmentCommon: "Porte principale (partagée)",
    assignmentUnit: "Porte de l'appartement",
    hintNone: "Elle ne sera pas contrôlée depuis le PMS.",
    hintGate: "Portail : il peut uniquement être actionné pour ouvrir (pas de prise en charge du verrouillage/PIN).",
    hintUnit: "Elle sera liée à cet hébergement pour le contrôle/les PIN.",
    unitLabel: "Logement / Hébergement",
    unitSelect: "Sélectionnez un logement",
    unitHint: "Sélectionnez quel logement cette serrure ouvre.",
    nameLabel: "Nom (facultatif)",
    namePlaceholder: "Par ex. Porte principale / Appt 101",
    nameHint: "Ce nom est enregistré lorsque vous enregistrez à nouveau le sélecteur de serrures.",
    actions: {
      lock: "Verrouiller",
      unlock: "Déverrouiller",
      createPin: "Créer un PIN",
      pinHistory: "Historique des PIN",
      openGate: "Ouvrir le portail (impulsion)",
      refresh: "Actualiser le statut",
    },
    save: "Enregistrer l'attribution",
    tipA: "Astuce : attribuez une porte principale ou un logement et appuyez sur",
    tipBold: "Enregistrer l'attribution",
    tipB: ". Les boutons sont activés une fois l'appareil attribué.",
  },

  pinHistory: {
    title: "Historique des PIN",
    loading: "Chargement de l'historique…",
    empty: "Aucun PIN enregistré pour cette serrure.",
    colAlias: "Alias",
    colPin: "PIN",
    colValidity: "Validité",
    colState: "Statut",
    createdPrefix: "Créé :",
    fromLabel: "Du :",
    toLabel: "Au :",
    revokeTitle: "Supprimer / Révoquer le PIN",
    noteA: '* "Actif" est calculé en comparant la date/heure actuelle avec',
    noteMid: "et",
    noteEnd: ".",
    close: "Fermer",
  },

  pinModal: {
    title: "Créer un PIN",
    nameLabel: "Nom / Étiquette",
    namePlaceholder: "Par ex. Ménage / Client / Technicien",
    pinLabel: "PIN",
    pinPlaceholder: "6 chiffres",
    generateTitle: "Générer",
    pinHint: "Si vous le laissez vide, le système en génère un.",
    modeLabel: "Mode",
    modeTimeLimited: "Avec dates",
    modeOngoing: "Sans dates (jusqu'à révocation)",
    validFrom: "Valable à partir du",
    validTo: "Valable jusqu'au",
    tipLabel: "Astuce :",
    tipText: "Pour un client, utilisez un PIN avec des dates de check-in/check-out.",
    cancel: "Annuler",
    creating: "Création...",
    create: "Créer un PIN",
  },

  toast: {
    noLocksFound: "Aucune serrure (type 2/5) n'a été trouvée dans Tedee.",
    loadStatusError: "Impossible de charger le statut de la serrure",
    loadStatusError2: "Erreur lors du chargement du statut de la serrure",
    needKey: "Vous devez saisir une Personal Access Key ou avoir une clé enregistrée.",
    connectionOk: "Connexion réussie. {count} appareil(s) trouvé(s).",
    testError: "Erreur lors du test de la connexion",
    needValidKey:
      "Vous devez saisir une Personal Access Key valide (au moins 10 caractères).",
    credentialsSaved: "Identifiants enregistrés avec succès",
    saveCredentialsError: "Erreur lors de l'enregistrement des identifiants",
    saveCredentialsErrorPrefix: "Erreur lors de l'enregistrement des identifiants : ",
    needOneDevice: "Vous devez sélectionner au moins un appareil pour cet hébergement.",
    devicesSaved: "Appareils enregistrés pour cet hébergement",
    devicesSaveError: "Impossible d'enregistrer les appareils",
    saveErrorPrefix: "Erreur lors de l'enregistrement : ",
    gateNoLock:
      "Le portail (type 5) ne prend pas en charge le verrouillage. Il peut uniquement être actionné pour ouvrir.",
    locked: "Serrure verrouillée",
    lockError: "Impossible de verrouiller",
    lockError2: "Erreur lors du verrouillage",
    gateOpened: "Portail ouvert (impulsion)",
    unlocked: "Serrure déverrouillée",
    unlockError: "Impossible de déverrouiller",
    unlockError2: "Erreur lors du déverrouillage",
    needUnitForApartment:
      "Sélectionnez le logement pour les serrures attribuées comme « Porte de l'appartement ».",
    bindingsSaved: "Attribution enregistrée avec succès",
    bindingsSaveError: "Impossible d'enregistrer l'attribution",
    bindingsSaveErrorPrefix: "Erreur lors de l'enregistrement de l'attribution : ",
    gateNoPin: "Le portail (type 5) ne prend pas en charge les PIN.",
    assignFirst:
      "Attribuez d'abord la serrure (porte principale ou logement) et enregistrez pour activer le contrôle.",
    needPinName: "Vous devez fournir un nom/une étiquette pour le PIN.",
    needValidDates: "Vous devez fournir une date de début et une date de fin valides.",
    pinCreated: "PIN créé avec succès",
    pinCreateError: "Impossible de créer le PIN",
    pinCreateError2: "Erreur lors de la création du PIN",
    gateNoPinHistory: "Le portail (type 5) ne prend pas en charge l'historique des PIN.",
    historyLoadError: "Impossible de charger l'historique",
    historyLoadError2: "Erreur lors du chargement de l'historique",
    noProviderPinId:
      "Ce PIN n'a pas de provider_pin_id. Il ne peut pas être révoqué dans Tedee.",
    pinRevoked: "PIN révoqué",
    revokeError: "Impossible de révoquer",
    revokeError2: "Erreur lors de la révocation du PIN",
  },

  confirm: {
    revokePin: 'Êtes-vous sûr de vouloir révoquer/supprimer le PIN « {alias} » ?',
  },

  pinState: {
    active: "Actif",
    upcoming: "À venir",
    expired: "Expiré",
    revoked: "Révoqué",
    none: "Sans dates",
  },
};
